// We only need to import the modules necessary for initial render
import CoreLayout from '../layouts/PageLayout'
import Home from './Home'
import Search from './Search'
import ProductsList from './ProductsList'
import ProductDetail from './ProductDetail'
import CartList from './CartList'
import Summary from './Summary'
import Orders from './Orders'
import OrderDetail from './OrderDetail'
import Login from './Login'
import Salesmen from './Salesmen'
import CustomerList from './CustomerList'
import Sales from './Sales'
import NotFound from './404'

/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */

export const createRoutes = store => ({
  path: '/',
  component: CoreLayout,
  indexRoute: Home,
  childRoutes: [
    CartList(store),
    Summary(store),
    Orders(store),
    OrderDetail(store),
    CustomerList(store),
    Login,
    Salesmen,
    Sales,
    // must be on last position, never move it higher
    Search(store),
    ProductsList(store),
    ProductDetail(store),
    NotFound,
  ],
})

/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js